import { dynamicTranslations } from "@shared/utils/dynamicTranslation";
import { Text, View } from "react-native";
import { TDeviceIssueConfig } from "../../constants/deviceIssueConfig";

export const DeviceTroubleshootingSteps = (config: TDeviceIssueConfig) => {
  const { t } = dynamicTranslations();
  return (
    <View className="flex-col gap-4">
      <Text className="text-gray-500 text-base font-semibold uppercase">
        {t('screens.deviceTroubleshooting.stepsLabel')}
      </Text>
      {config.page.stepKeys.map((stepKey, index) => (
        <View key={stepKey} className="flex-row items-center gap-3">
          <View className="w-9 h-9 rounded-full bg-secondary-700 items-center justify-center">
            <Text className="text-white font-bold">{index + 1}</Text>
          </View>
          <Text className="flex-1 text-base">{t(stepKey)}</Text>
        </View>
      ))}
    </View>
  )
}